import PropTypes from 'prop-types';

/* PropTypes */

export const JobSpellCheckPopupProptypes = {
  datasheets: PropTypes.array.isRequired,
  isSavingJobResultsLoading: PropTypes.bool.isRequired,
  jobId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaveChecklist: PropTypes.func.isRequired,
  onSaveDatasheet: PropTypes.func.isRequired,
  setResults: PropTypes.func.isRequired,
  storedChecklistsResults: PropTypes.array.isRequired,
  storedDatasheetsResults: PropTypes.array.isRequired,
};

export const BottomButtonsWrapperPropTypes = {
  ignoreButtonsDisabled: PropTypes.bool.isRequired,
  onIgnore: PropTypes.func.isRequired,
  onIgnoreAll: PropTypes.func.isRequired,
  onReplace: PropTypes.func.isRequired,
  onReplaceAll: PropTypes.func.isRequired,
  replaceButtonsDisabled: PropTypes.bool.isRequired,
};

export const HeaderButtonsWrapperPropTypes = {
  disabled: PropTypes.bool.isRequired,
  disabledNext: PropTypes.bool,
  disabledPrevious: PropTypes.bool,
  onSelectNext: PropTypes.func.isRequired,
  onSelectPrevious: PropTypes.func.isRequired,
};

/* DefaultProps */

export const HeaderButtonsWrapperDefaultProps = {
  disabledNext: false,
  disabledPrevious: false,
};
